export const programMap = {
  BPU: 'Second Step® Bullying Prevention Unit Training',
  CPU: 'Second Step® Child Protection Unit Training',
  K8P: 'Second Step® K8 Digital Program',
  MSP: 'Second Step® K8 Digital Program',
  SSP: 'Second Step® K8 Digital Program',
  SELA: 'Second Step® SEL for Adults Program',
}
